module.exports = __webpack_public_path__ + "img/ct_bru-composition2.8945e35e.png";